module.exports = __webpack_public_path__ + "static/media/srn.14108240.svg";